<app-lis-profile-generator
  [options]="dialogOptions"
  (profileChange)="_onFeedingProfileUpdate($event)"
  >
</app-lis-profile-generator>

<ng-template #buttonTemplate>
  @if (dialogOptions.readonly === false) {
    <button
      mat-raised-button
      color="primary"
      class="lis-generator-add-row-button"
      (click)="_addRow()"
      >
      <ion-icon name="add-circle-outline"></ion-icon>
      Add sequence
    </button>
    <button
      mat-stroked-button
      color="accent"
      (click)="closeDialog()"
    >
      Close
    </button>
    <app-split-button
      [disabled]="!hasValidProfile"
      (click)="_closeAndReturnProfile()"
      class="ml-1"
      >
      <ng-container buttonContent>
        Apply profile
      </ng-container>
      <button
        [disabled]="!hasValidProfile"
        mat-menu-item
        (click)="_saveAsCopy()"
        >
        Save as new profile
      </button>
    </app-split-button>
  }

  @if (dialogOptions.readonly === true) {
      <button
        mat-stroked-button
        (click)="closeDialog()"
      >
        Close
      </button>
  }
</ng-template>

@if (askForCopyName) {
  <!-- Display overlay which asks for a new name to save the profile under -->
  <div class="overlay-wrapper">
    <div class="input-wrapper">
      <mat-form-field>
        <mat-label>Enter a new profile name</mat-label>
        <input
          matInput
          type="text"
          [formControl]="newProfileNameControl"
          required
          minlength="1"
          />
        @if (newProfileNameControl.invalid) {
          <mat-error>
            {{ profileNameErrorMessage }}
          </mat-error>
        }
      </mat-form-field>
      <div class="button-row">
        <button
          mat-raised-button
          color="accent"
          (click)="_stopProfileCopyCreation()"
          >
          Abort
        </button>
        <button
          [disabled]="newProfileNameControl.invalid"
          mat-raised-button
          color="primary"
          (appButtonClick)="$event.waitFor(_createProfileCopyAndClose())"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
}
